import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './hero.module.css';

// Import images
import hero1 from '../../assets/hero/hero_1.png';
import hero2 from '../../assets/hero/hero_2.png';
import hero3 from '../../assets/hero/hero_3.png';
import hero4 from '../../assets/hero/hero_4.png';
import hero5 from '../../assets/hero/hero_5.png';
import hero6 from '../../assets/hero/hero_6.png';

const sliderImages = [hero1, hero2, hero3, hero4, hero5, hero6];

interface HeroProps {
  onGetStarted?: () => void;
}

export function Hero({ onGetStarted }: HeroProps) {
  const [currentSlide, setCurrentSlide] = useState(0);


  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % sliderImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className={styles.heroSection}>
      {/* Background Slider */}
      <div className={styles.sliderContainer}>
        <AnimatePresence initial={false}>
          <motion.div
            key={currentSlide}
            className={styles.slide}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 2, ease: "linear" }}
            style={{ backgroundImage: `url(${sliderImages[currentSlide]})` }}
          />
        </AnimatePresence>
        <div className={styles.overlay} />
      </div>


      <Container className={styles.heroContent}>
        <Row className="justify-content-center py-5">
          <Col lg={10} className="text-center">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <h1 className={styles.heroTitle}>
                Master the Skills to <span className={styles.highlight}>Build the Future</span> of Data Science
              </h1>
              <p className={styles.heroSubtitle}>
                Learn faster with a modern, project-first curriculum and mentorship designed for real careers in data and analytics.
              </p>
              <div className={styles.heroActions}>
                <Link to="/courses" className={`${styles.btnPill} ${styles.btnAccent}`}>
                  See All Courses
                </Link>
                <button 
                  onClick={onGetStarted}
                  className={`${styles.btnPill} ${styles.btnPrimary}`}
                  style={{ border: 'none', cursor: 'pointer' }}
                >
                  Get Started
                </button>
              </div>

            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}


